/**
 * RamRuling - the GM rules a ram (plan map-display, D): the damage the
 * target takes and the share the bow takes, typed, then Ram. No house rule
 * computes either (engine/actions/ram). Shown in the asks tray: for the
 * GM's own ram, and for a player's, which it answers.
 */
import { useState } from 'react';
import common from '../../styles/common.module.css';
import styles from '../../styles/CallForTest.module.css';
import NumberInput from '../NumberInput';

/**
 * @param {object} props
 * @param {{rammer: string, target: string}} props.question
 * @param {(ruling: {damage: number, bow: number}) => void} props.onSubmit
 * @param {() => void} props.onCancel
 * @param {string} [props.askId] - the ask it answers, for the fuzzer
 */
export default function RamRuling({ question, onSubmit, onCancel, askId }) {
  const [damage, setDamage] = useState(0);
  const [bow, setBow] = useState(0);
  return (
    <div className={styles.callLine} data-testid="ram-ruling" data-ask-id={askId}>
      <span>
        {question.rammer} rams {question.target}: rule the damage.
      </span>
      <NumberInput
        className={common.input}
        aria-label="Ram damage to the target"
        data-testid="ram-damage"
        min={0}
        value={damage}
        onChange={setDamage}
      />
      <NumberInput
        className={common.input}
        aria-label="Ram damage the bow takes"
        data-testid="ram-bow"
        min={0}
        value={bow}
        onChange={setBow}
      />
      <button
        type="button"
        className={common.btnDodge}
        data-testid="ram-submit"
        onClick={() => onSubmit({ damage, bow })}
      >
        Ram
      </button>
      <button type="button" className={common.btnSmall} data-testid="ram-cancel" onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}
